module.exports = __webpack_public_path__ + "static/menu-beverage-f07233cba4c5ba64454a8bffdf2a3d3b.png";